export default class Message {
    constructor(content, self, label) {
        if(typeof content === 'string') {
            this.text = content;
        } else {
            this.text = JSON.stringify(content);
        }

        this.id = Math.floor((Math.random() * 1000) + 1);
        this.self = self;
        this.label = label;
    }

    getText() {
        return this.text;
    }
}


// WEBPACK FOOTER //
// ./src/components/dialog/message.js